import { render, staticRenderFns } from "./projection-selector.vue?vue&type=template&id=35cfd342&"
import script from "./projection-selector.vue?vue&type=script&lang=js&"
export * from "./projection-selector.vue?vue&type=script&lang=js&"
import style0 from "./_projection-selector.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports